import { generateUUID } from '@mmt/navigation/src/util';
import { getAppLaunchSource, getSessionID } from '../../Utils/CommonUtils';
import { getTimeZone } from './PdtV2Utils';
import {
  getPokusConfigExpDetailsListV2,
  getPokusExpVarientKey,
} from '@mmt/legacy-commons/Native/AbConfig/AbConfigModule';
import { PokusLobs } from '@mmt/legacy-commons/Native/AbConfig/AbConfigKeyMappings';
import {
  ENV_DEV,
  ENV_PROD,
  BU_GROUND_TRANSPORT,
  ORGANISATION_MMT,
  FUNNEL_ENTRY_LANDING,
  TRAFFIC_SOURCE_ORGANIC,
} from '../../Utils/RailsConstant';

export const COMMON_PDT_CONSTANTS = {
  PRODUCT_CLICKED_EVENT: 'product-clicked',
  CONTENT_CTA_CLICKED: 'content_cta-clicked',
  ACTION_EVENT: 'action',
  LIFE_CYCLE_EVENT: 'page',
  PAGE_LOAD_EVENT: 'page-rendered',
  BUTTON_CLICKED: 'button-clicked',
};

export const COMMON_EVENT_TRACKING_CONTEXT = async () => {
  return {
    env: __DEV__ ? ENV_DEV : ENV_PROD,
    timezone: getTimeZone(),
    session_id: await getSessionID(),
    funnel_source: await getAppLaunchSource(),
    funnel_entry: FUNNEL_ENTRY_LANDING,
    bu: BU_GROUND_TRANSPORT,
    organisation: ORGANISATION_MMT,
    journey_id: generateUUID(),
    traffic_source: TRAFFIC_SOURCE_ORGANIC,
  };
};

export const EXPERIMENT_DETAILS_CONTEXT = () => {
  try {
    let expDetailsList = getPokusConfigExpDetailsListV2(PokusLobs.RAIL, []) || [];
    const expVariantKey = getPokusExpVarientKey(PokusLobs.RAIL, '') || '';
    
    if (expDetailsList.length === 0 && expVariantKey) {
      expDetailsList = expVariantKey.split(',').map((key: string) => key.trim()).filter((key: string) => key.length > 0);
    }
    
    return {
      experiment_details: {
        valid_exp_list: expDetailsList,
        variant_keys: expVariantKey,
        honoured_exp_list: [],
      },
    };
  } catch (error) {
    console.error('Error in getting experiment details for PDT event', error);
    return {};
  }
};

export const PDT_JOURNEY_ID_KEY = 'rails_pdt_journey_id';
export const PDT_PNR_JOURNEY_ID_KEY = 'rails_pdt_pnr_journey_id';
